/* Bandeau cookies maison, branché sur l'API de confidentialité de Shopify.
   Règles : rien n'est enregistré sans clic du visiteur ; refuser prend un clic,
   comme accepter ; le choix est redemandé au bout de six mois ; le bouton
   « Gérer mes cookies » du footer rouvre le bandeau sur le détail. */
(function () {
  var root = document.querySelector('[data-cookies]');
  if (!root) return;

  var CLE_DATE = 'sm_cookies_date';
  var SIX_MOIS = 182 * 24 * 60 * 60 * 1000;
  var api = null;

  var niv1 = root.querySelector('[data-ck-niv1]');
  var niv2 = root.querySelector('[data-ck-niv2]');
  var titre = root.querySelector('#ck-titre');
  var live = root.querySelector('[data-ck-live]');
  var btnChoisir = root.querySelector('[data-ck="choisir"]');
  var cases = {};
  root.querySelectorAll('[data-ck-cat]').forEach(function (c) {
    cases[c.getAttribute('data-ck-cat')] = c;
  });

  function lireDate() {
    try { return parseInt(localStorage.getItem(CLE_DATE), 10) || 0; } catch (e) { return 0; }
  }
  function ecrireDate() {
    try { localStorage.setItem(CLE_DATE, String(Date.now())); } catch (e) { /* stockage indisponible */ }
  }

  function montrerNiveau(deux) {
    niv1.hidden = !!deux;
    niv2.hidden = !deux;
    btnChoisir.setAttribute('aria-expanded', deux ? 'true' : 'false');
  }

  function ouvrir(detail, focus) {
    montrerNiveau(!!detail);
    root.hidden = false;
    /* le display:none doit être levé (reflow forcé) avant la transition */
    void root.offsetWidth;
    setTimeout(function () { root.classList.add('is-open'); }, 20);
    if (focus) titre.focus({ preventScroll: true });
  }

  function fermer() {
    root.classList.remove('is-open');
    setTimeout(function () { root.hidden = true; montrerNiveau(false); }, 350);
  }

  /* précoche le détail avec le choix déjà enregistré (réouverture) */
  function precocher() {
    if (!api) return;
    var c = api.currentVisitorConsent();
    Object.keys(cases).forEach(function (k) {
      cases[k].checked = c[k] === 'yes';
    });
  }

  function enregistrer(choix) {
    var consent = {
      analytics: !!choix.analytics,
      marketing: !!choix.marketing,
      preferences: !!choix.preferences,
      /* vente de données (régions US) : suit la publicité */
      sale_of_data: !!choix.marketing
    };
    var fin = function () {
      ecrireDate();
      fermer();
      if (live) live.textContent = live.getAttribute('data-msg') || '';
    };
    if (!api) { fin(); return; }
    api.setTrackingConsent(consent, fin);
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ck]');
    if (!b) return;
    switch (b.getAttribute('data-ck')) {
      case 'tout':
        enregistrer({ analytics: true, marketing: true, preferences: true });
        break;
      case 'rien':
        enregistrer({});
        break;
      case 'valider':
        enregistrer({
          analytics: cases.analytics && cases.analytics.checked,
          marketing: cases.marketing && cases.marketing.checked,
          preferences: cases.preferences && cases.preferences.checked
        });
        break;
      case 'choisir':
        montrerNiveau(true);
        break;
      case 'retour':
        montrerNiveau(false);
        break;
    }
  });

  /* Échap : replie le bandeau sans rien enregistrer (rien n'est déposé) */
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermer();
  });

  /* « Gérer mes cookies » (footer ou n'importe où) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cookies-ouvrir]');
    if (!b) return;
    e.preventDefault();
    precocher();
    ouvrir(true, true);
  });

  /* Éditeur de thème : toujours visible pour régler les textes */
  if (root.hasAttribute('data-design')) {
    ouvrir(false, false);
    return;
  }

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (erreur) {
      if (erreur) return;
      api = window.Shopify.customerPrivacy;
      var c = api.currentVisitorConsent();
      var dejaChoisi = c.analytics !== '' || c.marketing !== '';
      /* shouldShowBanner() dit si la région exige le consentement ; observé
         comme restant vrai après un choix, d'où la vérification du choix ici */
      var regionConsentement = api.shouldShowBanner() || !!(api.getRegulation && api.getRegulation());
      var afficher = regionConsentement && !dejaChoisi;

      if (regionConsentement && dejaChoisi) {
        var date = lireDate();
        if (!date) {
          ecrireDate(); /* choix fait avant ce bandeau : on date à aujourd'hui */
        } else if (Date.now() - date > SIX_MOIS) {
          afficher = true; /* bonne pratique CNIL : redemander après six mois */
        }
      }

      if (afficher) ouvrir(false, false);
    }
  );
})();
